/**
 * Извлекает домен из URL, убирая протокол, www и параметры
 *
 * @param url - URL для обработки
 * @returns Домен без www и протокола, или пустую строку если URL невалидный
 *
 * @example
 * getDomainFromUrl('http://example.com/path?param=value') // 'example.com'
 * getDomainFromUrl('invalid-url') // ''
 * getDomainFromUrl('') // ''
 */
export const getDomainFromUrl = (url: string): string => {
    if (!url || typeof url !== 'string') {
        return '';
    }

    let domain = url.replace(/^https?:\/\//, '');

    domain = domain.split('/')[0];

    domain = domain.split(':')[0];

    if (!domain.includes('.')) {
        return '';
    }

    if (domain.startsWith('www.')) {
        domain = domain.substring(4);
    }

    return domain;
};
